<div
  class="flex flex-col md:flex-row justify-between items-center gap-4 mt-4"
  [ngClass]="{ 'max-md:hidden': hideOnMobile }"
  *ngIf="!isEmpty"
>
  <!-- SUMMARY TEXT (LEFT SIDE) -->
  <div class="text-[13px] text-[#62777E]" *ngIf="showSummary">
    Showing {{ summaryStart }} to {{ summaryEnd }} of {{ totalItems }}
  </div>

  <!-- PAGINATION CONTROLS (RIGHT SIDE) -->
  <div class="flex flex-col md:flex-row items-center gap-4">
    <!-- PAGE NUMBERS -->
    <div class="flex items-center gap-1.5">
      <button
        class="btn btn-secondary btn-sm !w-[38px] !min-w-0 !px-0"
        [disabled]="currentPage === 1"
        (click)="onPageChange(currentPage - 1)"
        aria-label="Previous page"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-chevron-left" aria-hidden="true"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M15 6l-6 6l6 6" /></svg>
      </button>

      <ng-container *ngFor="let p of pageNumbers">
        <button
          class="btn btn-sm !w-[38px] !min-w-0 !px-0"
          [ngClass]="p === currentPage ? 'btn-primary' : 'btn-secondary'"
          (click)="onPageChange(p)"
          *ngIf="shouldShowPageNumber(p)"
          [attr.aria-label]="'Page ' + p"
          [attr.aria-current]="p === currentPage ? 'page' : null"
        >
          {{ p }}
        </button>
        <span *ngIf="shouldShowLeftEllipsis(p)" class="px-1 text-[#8FADB2]">...</span>
        <span *ngIf="shouldShowRightEllipsis(p)" class="px-1 text-[#8FADB2]">...</span>
      </ng-container>

      <button
        class="btn btn-secondary btn-sm !w-[38px] !min-w-0 !px-0"
        [disabled]="currentPage === totalPages"
        (click)="onPageChange(currentPage + 1)"
        aria-label="Next page"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-chevron-right" aria-hidden="true"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M9 6l6 6l-6 6" /></svg>
      </button>
    </div>

    <!-- PAGE SIZE -->
    <div class="flex items-center gap-2">
      <span class="text-[12px] text-[#62777E]">Results per page:</span>
      <ng-select
        class="custom-ng-select w-20"
        [items]="pageSizes"
        [(ngModel)]="pageSize"
        (change)="onPageSizeChange()"
        [clearable]="false"
        [searchable]="false"
        appendTo="body"
      >
      </ng-select>
    </div>
  </div>
</div>

